import { Box, Button, Grid, Paper, Slide, Typography } from "@material-ui/core";
import useStyles from "components/app/styles";
import React from "react";
const Question = (props) => {
  const classes = useStyles();
  const transitionTime = 500;

  const onClickButton1 = () => {
    if (props.onClickBtn1) {
      props.onClickBtn1();
    }
  };

  const onClickButton2 = () => {
    if (props.onClickBtn2) {
      props.onClickBtn2();
    }
  };
  return (
    <Slide
      direction={props.direction ? props.direction : "up"}
      in={props.show}
      mountOnEnter
      unmountOnExit
      timeout={transitionTime}
    >
      <Paper elevation={4} className={classes.paper}>
        <Grid item xs>
          <Box m={1} className={classes.title}>
            <Typography gutterBottom style={{ fontSize: 26, fontWeight: 600 }}>
              {props.title}
            </Typography>
          </Box>
          <Box className={classes.tileContent}>
            <Typography variant="body2" gutterBottom>
              {props.description}
            </Typography>
          </Box>
        </Grid>
        <Box className={classes.buttonBox}>
          <Grid container justify="space-around" alignContent="center">
            {props.btn1Text && (
              <Grid
                item
                className={classes.gridItem}
                lg={props.large ? props.large : 2}
                sm={props.small ? props.small : 4}
                xs={11}
              >
                <Button
                  fullWidth
                  variant="outlined"
                  className={classes.but}
                  onClick={onClickButton1}
                >
                  {props.btn1Text}
                </Button>
              </Grid>
            )}
            {props.btn2Text && (
              <Grid
                item
                className={classes.gridItem}
                lg={props.large ? props.large : 2}
                sm={props.small ? props.small : 4}
                xs={11}
              >
                <Button
                  fullWidth
                  variant="outlined"
                  className={classes.but}
                  onClick={onClickButton2}
                >
                  {props.btn2Text}
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>
      </Paper>
    </Slide>
  );
};
export default Question;
